import { useEffect, useRef } from 'react';

function MmsDashboardRendererWrapper({
  dashboarddata,
  viewmode,
  graphtype,
  graphdata,
  graphoptions,
  colourarray,
  onGraphClicked,
}) {
  const elementRef = useRef(null);

  // Set inputs (custom properties)
  useEffect(() => {
    const el = elementRef.current;
    if (el) {
      el.dashboarddata = dashboarddata;
      el.viewmode = viewmode;
      el.graphtype = graphtype;
      el.graphdata = graphdata;
      el.graphoptions = graphoptions;
      el.colourarray = colourarray;
    }
  }, [dashboarddata, viewmode, graphtype, graphdata, graphoptions, colourarray]);

  // Bind custom event
  useEffect(() => {
    const el = elementRef.current;
    if (!el) return;

    const handleGraphClicked = (e) => {
      if (onGraphClicked) {
        onGraphClicked(e.detail);
      }
    };

    el.addEventListener('graphClicked', handleGraphClicked);
    return () => {
      el.removeEventListener('graphClicked', handleGraphClicked);
    };
  }, [onGraphClicked]);

  return <mms-dashboard-renderer ref={elementRef}></mms-dashboard-renderer>;
}

export default MmsDashboardRendererWrapper;
